interface WhiteLabelTheme {
  navBackground: string;
  navText: string;
}

export const updateZendeskTheme = (theme: WhiteLabelTheme | null) => {
  if (!window.zE || !theme) return;

  window.zE("webWidget", "updateSettings", {
    webWidget: {
      color: {
        theme: theme.navBackground,
        launcher: theme.navBackground,
        launcherText: theme.navText,
        button: theme.navBackground,
        header: theme.navBackground,
      },
    },
  });
};

declare global {
  interface Window {
    zE?: (command: string, action: string, settings?: unknown) => void;
  }
}
